import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import ContactPhoto from '@contact/components/View/ContactPhoto.vue'
import ViewForm from '@contact/components/View/ViewForm.vue'
import { mapGetters } from 'vuex';
import * as types from '@contact/store/types'
import api from '@contact/api'
import { ContactsStoredType } from '../types';
import { DeleteMode } from '@/modules/mail/types/enums';

@Component({
    components: { ContactPhoto, ViewForm },
    computed: {
        ...mapGetters({
            currentItem: types.CURRENT_CONTACT_ITEM
        })
    }

})
export default class ViewContainer extends Vue {
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    item!: contacts.ContactItem

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    currentItem!: contacts.ContactItem

    async deleteItem() {
        if (await(window as any).confirmAsync(this.$t('정말_삭제하시겠습니까').toString())) {
            let ids = [this.item.id]
            let option = DeleteMode.MoveToDeletedItems
            let storedType = ContactsStoredType.EWS
            api.contact.deleteContacts(ids, option, storedType).then((res) => {
                if (res) {
                    this.$router.push({ path: '/contact/list' })
                }
            });
        } else {
            return false
        }
    }

    @Watch('currentItem')
    onChangedCurrentItem(newValue: contacts.ContactItem) {
        this.item = newValue
    }

    created() {
        this.item = this.currentItem
    }
}